// data/fbPixelEvent.js
// Defines the expected parameters for standard Facebook Pixel events.
// This is a data file, typically exported as a module.

module.exports = {
    "AddPaymentInfo": ["content_category", "content_ids", "contents", "currency", "value"],
    "AddToCart": ["content_ids", "content_name", "content_type", "contents", "currency", "value"],
    "AddToWishlist": ["content_name", "content_category", "content_ids", "contents", "currency", "value"],
    "CompleteRegistration": ["content_name", "currency", "status", "value"],
    "Contact": [],
    "CustomizeProduct": [],
    "Donate": [],
    "FindLocation": [],
    "PageView": ["content_ids", "content_name", "content_type"],
    "InitiateCheckout": ["content_category", "content_ids", "contents", "currency", "num_items", "value"],
    "Lead": ["content_category", "content_name", "currency", "value"],
    "Purchase": ["content_ids", "content_name", "content_type", "contents", "currency", "num_items", "value"],
    "Schedule": [],
    "Search": ["content_category", "content_ids", "content_type", "contents", "currency", "search_string", "value"],
    "StartTrial": ["currency", "predicted_ltv", "value"],
    "SubmitApplication": [],
    "Subscribe": ["currency", "predicted_ltv", "value"],
    "ViewContent": ["content_ids", "content_category", "content_name", "content_type", "contents", "currency", "value"],
};